import { t } from "i18next";
import ERPSBaseLink from "../custom/inputs/ERPSBaseLink";
import { formatUTCDate } from "../../utils/helper";
import { FI } from "../../constants/sharedConstants";

export const FI_SHORT_NAME_BY_NUMBER = {
  [FI.DND]: "BMO",
  [FI.BMO]: "BMO",
  [FI.BNS]: "BNS",
  [FI.CIBC]: "CIBC",
};

export const getFiShortName = (fiNumber) => FI_SHORT_NAME_BY_NUMBER[fiNumber] || fiNumber;

export const getBcrLinkCount = (row) => row?.links?.length || 0;

export const getMatchResultLabel = (row) => {
  const count = getBcrLinkCount(row);
  if (count === 0) return t("erps.billermanagement.bcrpendingapprovals.matchresult.none", "No match");
  if (count === 1) return t("erps.billermanagement.bcrpendingapprovals.matchresult.single", "Single match");
  return t("erps.billermanagement.bcrpendingapprovals.matchresult.multiple", "Multiple match");
};

export const getCentralizedBillerIdDisplay = (row) => {
  const count = getBcrLinkCount(row);
  if (count === 0) return "-";
  if (count === 1) return row.links[0]?.targetCentralizedBillerId || "-";
  return t("erps.billermanagement.bcrpendingapprovals.value.multipleids", "Multiple IDs");
};

export const getBcrPendingGridHeadings = () => [
  {
    field: "reviewId",
    headerName: t("erps.billermanagement.label.transactionid"),
    width: 130,
    sortable: false,
    renderCell: (params) => (
      <ERPSBaseLink
        to={{
          pathname: "/bcr-pending-approvals/review",
          state: { pendingBcr: params.row },
        }}
        className="link__blue"
        label={params.value.toString()}
      />
    ),
  },
  {
    field: "incomingBillerFi",
    headerName: t("erps.billermanagement.bcrpendingapprovals.label.incomingfi", "Incoming FI"),
    width: 130,
    sortable: false,
    renderCell: (params) => getFiShortName(params.value),
  },
  {
    field: "incomingBillerId",
    headerName: t("erps.billermanagement.bcrpendingapprovals.label.incomingbillerid", "Incoming Biller ID"),
    width: 170,
    sortable: false,
  },
  {
    field: "targetCentralizedBillerId",
    headerName: t("erps.billermanagement.crossreference.label.centralizedBillerId"),
    width: 190,
    sortable: false,
    renderCell: (params) => getCentralizedBillerIdDisplay(params.row),
  },
  {
    field: "updatedDate",
    headerName: t("erps.updatebillerapproval.label.updatedon"),
    width: 160,
    sortable: false,
    renderCell: (params) => (params.value ? formatUTCDate(params.value) : ""),
  },
  {
    field: "matchResult",
    headerName: t("erps.billermanagement.bcrpendingapprovals.label.matchresult", "Match Result"),
    width: 180,
    sortable: false,
    renderCell: (params) => getMatchResultLabel(params.row),
  },
];
